import { render, staticRenderFns } from "./NewCallComponent.vue?vue&type=template&id=1623e5be&scoped=true&"
import script from "./NewCallComponent.vue?vue&type=script&lang=js&"
export * from "./NewCallComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewCallComponent.vue?vue&type=style&index=0&id=1623e5be&prod&scoped=true&lang=scss&"
import style1 from "./NewCallComponent.vue?vue&type=style&index=1&id=1623e5be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623e5be",
  null
  
)

export default component.exports